import { IWlBalanceDataAPI } from '@/types/wlBalance';

export class WlBalanceItem {
    public balance: number;
    public balanceAgentBrl: number;
    public balanceAgentEuro: number;
    public balanceBookmakerBrl: number;
    public balanceBookmakerEuro: number;
    public betCount: number;
    public bookFeesBrl: number;
    public bookFeesEuro: number;
    public bookRebateBrl: number;
    public bookRebateEuro: number;
    public companyComBrl: number;
    public companyComEuro: number;
    public platformId: number | null;
    public playerComBrl: number;
    public playerComEuro: number;
    public settledStakeSum: number;

    constructor(data: IWlBalanceDataAPI) {
        this.platformId = data.platform_id;
        this.betCount = data.bet_count;
        this.settledStakeSum = data.settled_stake_sum;
        this.balance = data.balance;
        this.balanceAgentBrl = data.balance_agent_brl;
        this.balanceAgentEuro = data.balance_agent_euro;
        this.balanceBookmakerBrl = data.balance_bookmaker_brl;
        this.balanceBookmakerEuro = data.balance_bookmaker_euro;
        this.companyComBrl = data.company_com_brl;
        this.playerComBrl = data.player_com_brl;
        this.companyComEuro = data.company_com_euro;
        this.playerComEuro = data.player_com_euro;
        this.bookFeesBrl = data.book_fees_brl;
        this.bookFeesEuro = data.book_fees_euro;
        this.bookRebateBrl = data.book_rebate_brl;
        this.bookRebateEuro = data.book_rebate_euro;
    }

    get a2fFinalOperation(): number {
        return this.wlToTb - this.balance;
    }

    get companyPlBrl(): number {
        return this.balanceBookmakerBrl - this.balanceAgentBrl + this.companyComBrl - this.playerComBrl;
    }

    get companyPlEuro(): number {
        return this.balanceBookmakerEuro - this.balanceAgentEuro + this.companyComEuro - this.playerComEuro;
    }

    get isTotal(): boolean {
        return this.platformId === null;
    }

    get tbBookCommissionsEuro(): number {
        return this.companyComEuro + this.bookRebateEuro;
    }

    get tbFinalOperationBrl(): number {
        return this.companyPlBrl - this.bookFeesBrl - this.companyComBrl;
    }

    get tbFinalOperationEuro(): number {
        return this.companyPlEuro - this.bookFeesEuro - this.companyComEuro;
    }

    get tbToBookmakersBrl(): number {
        return this.balanceBookmakerBrl - this.bookFeesBrl;
    }

    get tbToBookmakersEuro(): number {
        return this.balanceBookmakerEuro - this.bookFeesEuro;
    }

    get wlToTb(): number {
        return this.tbToBookmakersBrl - this.tbFinalOperationBrl;
    }
}
